import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  fill: "currentColor",
  viewBox: "0 0 42.52 42.52"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21.75 5.36c-8.32 0-15.08 6.77-15.08 15.08 0 2.04.4 4.01 1.18 5.86l-2.69 8.49 8.51-1.62c2.42 1.54 5.2 2.35 8.08 2.35 8.32 0 15.08-6.77 15.08-15.08S30.06 5.36 21.75 5.36zm0 28.16c-2.62 0-5.15-.77-7.32-2.23l-.34-.23-6.02 1.14 1.91-6.02-.16-.35c-.77-1.7-1.16-3.51-1.16-5.4 0-7.21 5.87-13.08 13.08-13.08s13.08 5.87 13.08 13.08-5.87 13.08-13.08 13.08l.01.01z" }, null, -1)
  ])))
}
export default { render: render }